import React from 'react';
import { Icon } from './Icon.js';
export const IconAdjustContrast2Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M9,1C4.589,1,1,4.589,1,9s3.589,8,8,8,8-3.589,8-8S13.411,1,9,1Zm0,1.5c1.522,0,2.921,.53,4.03,1.41L3.909,13.03c-.88-1.109-1.409-2.508-1.409-4.03,0-3.584,2.916-6.5,6.5-6.5Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconAdjustContrast2Fill18.js.map